import { Container, Row, Col } from "react-bootstrap";
import ComingSoon from "../../../images/coming-soon.png";

const Coming = () => {
  return (
    <div>
      <Container>
        <Row className="my-5">
          <Col>
            <img src={ComingSoon} alt="Coming Soon" className="img-fluid" />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Coming;
